import { Controller } from '@hotwired/stimulus'
import './slide_component.scss'

export default class extends Controller {
  static values = {
    revealOnConnect: Boolean,
  }

  connect() {
    if (this.revealOnConnectValue) {
      // Dispatch event to parent slider to reveal this slide
      this.element.dispatchEvent(
        new CustomEvent('slide:reveal', {
          bubbles: true,
          detail: { slideElement: this.element },
        })
      )
    }
  }
}
